'use strict';

import React from 'react';
import { connect } from 'react-redux';
import { format } from 'date-fns';

import { assignmentsSelectors } from '@/state/domains/assignments';
import { attemptsOperations, attemptsSelectors } from '@/state/domains/attempts';

import Link from '@/views/common/Link';

import s from './styles.scss';

const Tr = connect(
	(state, props) => ({
		stats: assignmentsSelectors.getDayStats(state, props),
		assignments: assignmentsSelectors.getPageUserDayAssignments(state, props),
		jobsCount: assignmentsSelectors.getPropUserDayJobsCount(state, props),
	}),
	{
	}
)(
	({
		user,
		dateObj,
		date,
		assignments,
		jobsCount,
		stats,
	}) => {

		const dateStr = format(dateObj, 'EEE');

		let serves, badAddresses, attempts;

		if (stats) {
			serves = stats.serves;
			badAddresses = stats.badAddresses;
			attempts = stats.attempts;
		} else {
			serves = 0;
			badAddresses = 0;
			attempts = 0;
		}

		const total = serves + badAddresses + attempts;
		const ratio = total > 0 ? (100 * (serves + badAddresses) / total).toFixed(0) + '%' : '0%';

		return (
			<tr>
				<td className='date'>
					<Link to={ `/user/${ user.username }/${ date }/route` } >{ dateStr }</Link>
				</td>
				<td>{ jobsCount }</td>
				<td>{ serves }</td>
				<td>{ badAddresses }</td>
				<td>{ attempts }</td>
				<td>{ total }</td>
				<td>{ ratio }</td>
			</tr>
		);
	}
);

export default connect(
	(state, props) => ({
		assignments: assignmentsSelectors.getPropUserMultiDayAssignments(state, props),
	}),
	{
	}
)(
	({ user, assignments, weekDates, dates }) => {
		return (
			<div className={ s.stats }>
				<table className={ s.statsTable }>
					<thead>
						<tr>
							<th>Date</th>
							<th>Assigned</th>
							<th>Serves</th>
							<th>BA</th>
							<th>Attempted</th>
							<th>Total</th>
							<th>Ratio</th>
						</tr>
					</thead>
					<tbody>
						{
							weekDates.reduce(
								(trs, d, i) => {

									const date = format(d, 'yyyy-MM-dd');

									if (date in assignments && assignments[ date ]) {
										return [
											...trs,
											<Tr
												key={ i }
												user={ user }
												username={ user.username }
												dateObj={ d }
												date={ date }
											/>
										];
									}
									return trs;
								},
								[]
							)
						}
					</tbody>
				</table>
			</div>
		)
	}
);
